import React, {useEffect, useState} from "react";
import axios from "axios";
import moment from "moment";
import Calendar from "../components/Calendar";
import {getExtremeYears, prepareEvents} from "../helpers/eventsFilters";
import Navigator from "../components/Navigator";
import EventsInfo from "../components/EventsInfo";
import GlobalContext from "../GlobalContext";

const UpcomingEventsCalendars = ({url}) => {

  const [events, setEvents] = useState([]);
  const [selectedDay, setSelectedDay] = useState(moment().date());
  const [selectedMonth, setSelectedMonth] = useState(moment().month());
  const [selectedYear, setSelectedYear] = useState(moment().year());

  useEffect(() => {
    getData();
  }, []);

  function getData() {

    const language = drupalSettings.path.currentLanguage || ''

    const query = "/" + language + "/api/node/event";

    axios
      .get(query)
      .catch(error => {
        console.error(error);
      })
      .then(resp => {
        if (resp && resp.status === 200) {
          setEvents(prepareEvents(resp.data));
        } else {
          console.error("No data");
        }
      })
  }

  const CONTEXT = {
    events: events,
    eventsExtremeDates: getExtremeYears(events),
    selectedDay: selectedDay,
    selectedMonth: selectedMonth,
    selectedYear: selectedYear,
    setSelectedDay: day => setSelectedDay(day),
    setSelectedMonth: month => setSelectedMonth(month),
    setSelectedYear: year => setSelectedYear(year),
    dateFormat: 'YYYY-MM-DD',
    DAYS_TRANSLATIONS: [
      Drupal.t("Mon."),
      Drupal.t("Tue."),
      Drupal.t("Wed."),
      Drupal.t("Thu."),
      Drupal.t("Fri."),
      Drupal.t("Sat."),
      Drupal.t("Sun."),
    ],
    MONTHS_TRANSLATIONS: [
      Drupal.t("January"),
      Drupal.t("February"),
      Drupal.t("March"),
      Drupal.t("April"),
      Drupal.t("May"),
      Drupal.t("June"),
      Drupal.t("July"),
      Drupal.t("August"),
      Drupal.t("September"),
      Drupal.t("October"),
      Drupal.t("November"),
      Drupal.t("December")
    ]
  };

  return (
    <div className="upcoming-events-calendar-container">
      <GlobalContext.Provider value={CONTEXT}>
      <Navigator />
      <Calendar />
      <EventsInfo />
      </GlobalContext.Provider>
      {url ? <div className="d-flex justify-content-center">
        <a className="mt-2 btn btn-outline-warning" href={url}>{Drupal.t('See more')}</a>
      </div> : null}
    </div>
  );
};

export default UpcomingEventsCalendars;
